exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ss-pagehead {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n.top-check{\r\n    border-radius: 4px;\r\n    border: 1px solid #37c9c0;\r\n    background-color: #fff;\r\n    font-size: 12px;\r\n    padding: 4px 12px;\r\n    margin-top: 4px;\r\n}\r\n.top-check:hover{\r\n    background-color: #37c9c0;\r\n    color: #fff;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/loan/home-loan-tax-savings/home-loan-tax-savings.component.css
// module id = 635
// module chunks = 8